import React, { useState, useEffect, useRef } from "react";
import Image from "../../assets/img/ShiproneLogo.png";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllComponentList } from "../../redux/actions/manageComponent";
import { getTemplateCustomeField } from "../../redux/actions/bookingtemplate";
import swal from "@sweetalert/with-react";
import CustomeModal from "../modal-popup/customeModal";
import ReusableComponent from "./ReusableComponent";
import ReusableComponentSetting from "./ReusableComponentSetting";
import {
  SET_TEMPLATE_PREVIEW_DATA,
  CLEAR_COMPONENT_PREVIEW_DATA,
  RESET_SAVE_TEMPORARY_DATA,
  CLEAR_COMPONENT_GRID_LAYOUT_DATA,
  SET_TEMPLATE_GRID_LAYOUT_DATA,
  SET_RETAIN_PROPS,
  CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY,
} from "../../redux/constants/index";
import {
  getToDoControlsByActivityId,
  createandupdateActivityCustomFields,
  updateActivityCustomField,
} from "../../redux/actions/todo";
import {
  createBookingTemplate,
  updateBookingTemplate,
} from "../../redux/actions/bookingtemplate";
import ReusableGridLayoutPreview from "./ReusableGridLayoutPreview";
import InputField from "../input-field";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";

function CreateAndUpdateTemplate({ setStep }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const settingRef = useRef();
  const triggerRef = useRef();
  const { state, pathname } = location;

  const { componentGridLayoutData, bookingTemplateName } = useSelector(
    (state) => state.bookingTemplate
  );
  const { componentListData } = useSelector((state) => state.manageComponent);
  const { tempPageName, saveData } = useSelector(
    (state) => state.tempWindowsData
  );
  const { company, id } = useSelector((state) => state.auth);
  const { newtododata, parentToDoIdForCopy } = useSelector(
    (state) => state.todo
  );
  const { todoDataForUpdateInventory } = useSelector((state) => state.todo);

  const [showWatermark, setShowWatermark] = useState(true);
  const [componentForSetting, setComponentForSetting] = useState();
  const [deletedComponentIdList, setDeletedComponentIdList] = useState([]);
  const [showSetting, setShowSetting] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  // Function to get Component List
  const getComponentListData = () => {
    const request = {
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Unable to fetch component list"
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAllComponentList(request));
  };

  // close drawer on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (target === triggerRef?.current) {
        setShowSetting(false);
        setComponentForSetting();
      }
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // Function to get existing fields in booking template
  const getCustomeFieldsForBookingTemplate = () => {
    const request = {
      onError: (error) => {
        swal({
          content: <CustomeModal type="error" title="Error!" content={error} />,
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onSuccess: (data) => {
        if (data.length > 0) {
          let componentArr = [];
          for (const item of data) {
            if (item.component) {
              const obj = {
                component: {
                  componentType: item.component.type,
                  componentId: item.component.component_id,
                  componentName: item.component.label,
                  componentPlaceholder: item.component.placeholder,
                  componentTooltip: item.component.tooltip,
                  isCheckedByDefault: item.component.is_check_by_default,
                  validation: item.component.validation_api_id,
                  minimumValue: item.component.min,
                  maximumValue: item.component.max,
                  component_special_id: item.component.component_name,
                  priorDate: item.component.prior_date,
                  futureDate: item.component.future_date,
                  isMandatory: item.is_required,
                  dropDownOption: item.component.list_values
                    ? JSON.parse(item.component.list_values)
                    : item.component.list_values,
                  booking_template_custom_field_id:
                    item.booking_template_custom_field_id,
                },
                i: JSON.parse(item.grid_position).i,
                x: JSON.parse(item.grid_position).x,
                y: JSON.parse(item.grid_position).y,
                h: JSON.parse(item.grid_position).h,
                w: JSON.parse(item.grid_position).w,
                minH: JSON.parse(item.grid_position).minH,
                maxH: JSON.parse(item.grid_position).maxH,
              };
              componentArr.push(obj);
            }
          }
          dispatch({
            type: SET_TEMPLATE_GRID_LAYOUT_DATA,
            payload: componentArr,
          });
          setShowWatermark(false);
        }
      },
      booking_template_id: state,
    };

    dispatch(getTemplateCustomeField(request));
  };

  const getCutomeFieldsForManageToDo = (parent_toto_id_for_copy) => {
    const request = {
      activity_id: parent_toto_id_for_copy ? parent_toto_id_for_copy : state.id,
      onError: (error) => {
        swal({
          content: <CustomeModal type="error" title="Error!" content={error} />,
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onSuccess: (data) => {
        if (data.length > 0) {
          let componentArr = [];
          for (const item of data) {
            if (item.todo_component) {
              let obj = {
                component: {
                  componentType: item.todo_component.type,
                  componentId: item.todo_component.component_id,
                  componentName: item.todo_component.label,
                  componentPlaceholder: item.todo_component.placeholder,
                  componentTooltip: item.todo_component.tooltip,
                  isCheckedByDefault: item.todo_component.is_check_by_default,
                  validation: item.todo_component.validation_api_id,
                  minimumValue: item.todo_component.min,
                  maximumValue: item.todo_component.max,
                  component_special_id: item.todo_component.component_name,
                  priorDate: item.todo_component.prior_date,
                  futureDate: item.todo_component.future_date,
                  isMandatory: item.is_required,
                  dropDownOption: item.todo_component.list_values
                    ? JSON.parse(item.todo_component.list_values)
                    : item.todo_component.list_values,
                  custome_field_id: item.id,
                  is_immutable: Boolean(item?.is_immutable),
                },
                i: JSON.parse(item.grid_position).i,
                x: JSON.parse(item.grid_position).x,
                y: JSON.parse(item.grid_position).y,
                h: JSON.parse(item.grid_position).h,
                w: JSON.parse(item.grid_position).w,
                minH: JSON.parse(item.grid_position).minH,
                maxH: JSON.parse(item.grid_position).maxH,
              };

              const stakeholderOptions = item?.todo_component?.stakeholder_category_mappings?.map(ele => ele.collaborator_name);
              if(stakeholderOptions?.length > 0) obj.component.dropDownOption = stakeholderOptions;

              componentArr.push(obj);
            }
          }
          dispatch({
            type: SET_TEMPLATE_GRID_LAYOUT_DATA,
            payload: componentArr,
          });
          setShowWatermark(false);
        }
      },
    };
    dispatch(getToDoControlsByActivityId(request));
  };

  useEffect(() => {
    getComponentListData();
    if (tempPageName === "manage template" || tempPageName === "manage todo") {
      dispatch({ type: SET_TEMPLATE_GRID_LAYOUT_DATA, payload: saveData.data });
      setShowWatermark(false);
    } else if (componentGridLayoutData.length > 0) {
      setShowWatermark(false);
    } else {
      if (!pathname.includes("activity") && state) {
        getCustomeFieldsForBookingTemplate();
      } else if (pathname.includes("activity") && state) {
        getCutomeFieldsForManageToDo();
      } else if (pathname.includes("activity") && parentToDoIdForCopy) {
        getCutomeFieldsForManageToDo(parentToDoIdForCopy);
      }
    }

    // else if {
    //   dispatch({ type: CLEAR_COMPONENT_PREVIEW_DATA });
    //   // dispatch({ type: CLEAR_COMPONENT_GRID_LAYOUT_DATA });
    // }
  }, []);

  // Function which create payload for Manage To Do and Manage Template payload.
  const create_API_payload = (componentGridLayoutData, isActivity) => {
    const sortedComponentArray = componentGridLayoutData.sort((a, b) => {
      if (a.y === b.y) {
        return a.x - b.x;
      }
      return a.y - b.y;
    });

    const custom_fields = sortedComponentArray.map((element, index) => {
      const obj = {
        is_required: element.component.isMandatory,
        sequence: index + 1,
        component_id: element.component.componentId,
        grid_position: JSON.stringify({
          i: element.i,
          x: element.x,
          y: element.y,
          w: element.w,
          h: element.h,
          maxH: element.maxH,
          minH: element.minH,
        }),
      };
      if (isActivity) {
        obj.activity_id = newtododata;
      }
      return obj;
    });

    return isActivity
      ? { custom_fields }
      : {
          booking_template_name: bookingTemplateName,
          custom_fields,
        };
  };

  // Function to show success message
  const handleOnSuccess = (
    successMessage,
    isActivity,
    booking_template_id,
    isBookingUpdated
  ) => {
    if (tempPageName === "manage todo" || tempPageName === "manage template") {
      dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
    }

    dispatch({ type: CLEAR_COMPONENT_PREVIEW_DATA });
    dispatch({ type: CLEAR_COMPONENT_GRID_LAYOUT_DATA });
    if (isActivity) {
      setStep(3);
      // navigate("/activity/overview");
    } else {
      navigate("/booking/design/overview");
    }
    // swal({
    //   content: (
    //     <CustomeModal
    //       type="success"
    //       title="Success!"
    //       content={successMessage}
    //       onClick={() => {
    //         dispatch({ type: CLEAR_COMPONENT_PREVIEW_DATA });
    //         dispatch({ type: CLEAR_COMPONENT_GRID_LAYOUT_DATA });
    //         if (isActivity) {
    //           setStep(3);
    //           // navigate("/activity/overview");
    //         } else {
    //           navigate("/booking/design/overview");
    //         }
    //       }}
    //     />
    //   ),
    //   buttons: false,
    //   closeOnClickOutside: false,
    //   closeOnEsc: false,
    // });
  };

  // Function to show error message
  const handleOnError = (errorMessage) => {
    swal({
      content: (
        <CustomeModal type="error" title="Error!" content={errorMessage} />
      ),
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
    });
  };

  // Function to update custom fields on manage template page
  const updateCustomField = () => {
    setIsSaved(true);
    const sortedComponentArray = componentGridLayoutData.sort((a, b) => {
      if (a.y === b.y) {
        return a.x - b.x;
      }
      return a.y - b.y;
    });

    const custom_fields = sortedComponentArray.map((element, index) => {
      const obj = {
        is_required: element.component.isMandatory,
        sequence: index + 1,
        component_id: element.component.componentId,
        grid_position: JSON.stringify({
          i: element.i,
          x: element.x,
          y: element.y,
          w: element.w,
          h: element.h,
          maxH: element.maxH,
          minH: element.minH,
        }),
      };

      if (pathname.includes("activity")) {
        obj.activity_id = state.id; //Here state is actually ToDo id
        if (element?.component?.custome_field_id) {
          obj.id = element?.component?.custome_field_id;
        }
      } else {
        obj.booking_template_id = state;
        if (element?.component?.booking_template_custom_field_id) {
          obj.booking_template_custom_field_id =
            element?.component?.booking_template_custom_field_id;
        }
      }

      return obj;
    });

    const request = {
      payload: {
        custom_fields,
        deletedcontrols: deletedComponentIdList,
      },
      onSuccess: () => {
        const message = pathname.includes("activity")
          ? "Template has been updated successfully."
          : "To Do has been updated successfully.";
        handleOnSuccess(message, pathname.includes("activity"), state, true);
        setIsSaved(false);
      },
      onError: (error) => {
        handleOnError(error);
        setIsSaved(false);
      },
    };

    if (pathname.includes("activity")) {
      dispatch(updateActivityCustomField(request));
    } else {
      dispatch(updateBookingTemplate(request));
    }
  };

  // Function to add custom fields on manage template
  const addCustomField = () => {
    setIsSaved(true);
    const payload = create_API_payload(
      componentGridLayoutData,
      pathname.includes("activity")
    );

    if (pathname.includes("activity")) {
      const request = {
        payload,
        onError: () => {
          setIsSaved(false);
          handleOnError("Something went wrong, please try again later");
        },
        onSuccess: () => {
          handleOnSuccess(
            "To Do has been created successfully.",
            pathname.includes("activity")
          );
          dispatch({ type: CLEAR_COMPONENT_PREVIEW_DATA });
          dispatch({ type: CLEAR_COMPONENT_GRID_LAYOUT_DATA });
          setIsSaved(false);
        },
      };
      dispatch(createandupdateActivityCustomFields(request));
    } else {
      const request = {
        payload,
        onError: (error) => {
          handleOnError(error)
          setIsSaved(false);
        },
        onSuccess: (booking_template_id) => {
          handleOnSuccess(
            "Template has been created successfully.",
            pathname.includes("activity"),
            booking_template_id
          );
          setIsSaved(false);
        },
      };
      dispatch(createBookingTemplate(request));
    }
  };

  return (
    <div
      className={`${
        !pathname.includes("activity") && "mt-4 sm:mx-6 lg:mx-8"
      } h-screen space-x-4 flex overflow-x-hidden overflow-y-hidden`}
      style={{
        maxHeight: !pathname.includes("activity")
          ? "calc(100vh - 107px)"
          : "calc(100vh - 137px)",
      }}
    >
      <div className="w-1/4">
        <ReusableComponent setShowWatermark={setShowWatermark} />
      </div>
      <div className="w-3/4 relative">
        {/* Inventory To Do Component */}
        {todoDataForUpdateInventory && (
          <div className="my-3 px-3 py-6 bg-[--bg-color-50] rounded-md flex items-center justify-between w-full space-x-4">
            <div className="w-full space-y-2">
              <InputField
                label="SKU/Product"
                disabled
                placeholder="Item #1"
              />
              <InputField
                disabled
                placeholder={`Item #2`}
              />
              <InputField
                disabled
                placeholder={`Item #3`}
              />
              <InputField
                disabled
                placeholder={`Item #4`}
              />
              <InputField
                disabled
                placeholder={`Item #5`}
              />
            </div>
            <div className="w-full grid grid-cols-3 gap-4">
              <div className="space-y-2">
                <InputField
                  label="Planned Qty"
                  disabled
                  placeholder="Planned Qty"
                />
                <InputField disabled placeholder="Planned Qty" />
                <InputField disabled placeholder="Planned Qty" />
                <InputField disabled placeholder="Planned Qty" />
                <InputField disabled placeholder="Planned Qty" />
              </div>
              <div className="space-y-2">
                <InputField label="Actual Qty" placeholder="Actual Qty" />
                <InputField placeholder="Actual Qty" />
                <InputField placeholder="Actual Qty" />
                <InputField placeholder="Actual Qty" />
                <InputField placeholder="Actual Qty" />
              </div>
              <div className="space-y-2">
                <div className="w-full relative">
                  <label
                    className={`block text-sm font-medium mb-1 leading-3 tracking-tight`}
                    htmlFor="card-city"
                  >
                    Actual Date
                  </label>
                  <Flatpickr
                    data-enable-time
                    options={{
                      altFormat: "j M, Y",
                      dateFormat: "Y-m-d",
                      time_24hr: false,
                      disableMobile: true,
                      enableTime: false,
                      altInput: true,
                    }}
                    name="planned_date"
                    render={({ defaultValue }, ref) => {
                      return (
                        <div className="w-full">
                          <input
                            title="Component Placeholder"
                            className="form-input w-[100%] truncate disabled:border-slate-200"
                            defaultValue={defaultValue}
                            ref={ref}
                            placeholder="Actual Date"
                          />
                          <div className="absolute inset-0 left-auto !top-8 opacity-100 group">
                            <span className="text-sm text-slate-500 font-medium px-3 ">
                              <span className="far fa-calendar text-[#1E293B] z-60 bg-white"></span>
                            </span>
                          </div>
                        </div>
                      );
                    }}
                  />
                </div>
                <Flatpickr
                  data-enable-time
                  options={{
                    altFormat: "j M, Y",
                    dateFormat: "Y-m-d",
                    time_24hr: false,
                    disableMobile: true,
                    enableTime: false,
                    altInput: true,
                  }}
                  name="planned_date"
                  render={({ defaultValue }, ref) => {
                    return (
                      <div className="w-full relative">
                        <input
                          title="Component Placeholder"
                          className="form-input w-[100%] truncate disabled:border-slate-200"
                          defaultValue={defaultValue}
                          ref={ref}
                          placeholder="Actual Date"
                        />
                        <div className="absolute inset-0 left-auto !top-1.5 opacity-100 group">
                          <span className="text-sm text-slate-500 font-medium px-3 ">
                            <span className="far fa-calendar text-[#1E293B] z-60 bg-white"></span>
                          </span>
                        </div>
                      </div>
                    );
                  }}
                />
                <Flatpickr
                  data-enable-time
                  options={{
                    altFormat: "j M, Y",
                    dateFormat: "Y-m-d",
                    time_24hr: false,
                    disableMobile: true,
                    enableTime: false,
                    altInput: true,
                  }}
                  name="planned_date"
                  render={({ defaultValue }, ref) => {
                    return (
                      <div className="w-full relative">
                        <input
                          title="Component Placeholder"
                          className="form-input w-[100%] truncate disabled:border-slate-200"
                          defaultValue={defaultValue}
                          ref={ref}
                          placeholder="Actual Date"
                        />
                        <div className="absolute inset-0 left-auto !top-1.5 opacity-100 group">
                          <span className="text-sm text-slate-500 font-medium px-3 ">
                            <span className="far fa-calendar text-[#1E293B] z-60 bg-white"></span>
                          </span>
                        </div>
                      </div>
                    );
                  }}
                />
                <Flatpickr
                  data-enable-time
                  options={{
                    altFormat: "j M, Y",
                    dateFormat: "Y-m-d",
                    time_24hr: false,
                    disableMobile: true,
                    enableTime: false,
                    altInput: true,
                  }}
                  name="planned_date"
                  render={({ defaultValue }, ref) => {
                    return (
                      <div className="w-full relative">
                        <input
                          title="Component Placeholder"
                          className="form-input w-[100%] truncate disabled:border-slate-200"
                          defaultValue={defaultValue}
                          ref={ref}
                          placeholder="Actual Date"
                        />
                        <div className="absolute inset-0 left-auto !top-1.5 opacity-100 group">
                          <span className="text-sm text-slate-500 font-medium px-3 ">
                            <span className="far fa-calendar text-[#1E293B] z-60 bg-white"></span>
                          </span>
                        </div>
                      </div>
                    );
                  }}
                />
                <Flatpickr
                  data-enable-time
                  options={{
                    altFormat: "j M, Y",
                    dateFormat: "Y-m-d",
                    time_24hr: false,
                    disableMobile: true,
                    enableTime: false,
                    altInput: true,
                  }}
                  name="planned_date"
                  render={({ defaultValue }, ref) => {
                    return (
                      <div className="w-full relative">
                        <input
                          title="Component Placeholder"
                          className="form-input w-[100%] truncate disabled:border-slate-200"
                          defaultValue={defaultValue}
                          ref={ref}
                          placeholder="Actual Date"
                        />
                        <div className="absolute inset-0 left-auto !top-1.5 opacity-100 group">
                          <span className="text-sm text-slate-500 font-medium px-3 ">
                            <span className="far fa-calendar text-[#1E293B] z-60 bg-white"></span>
                          </span>
                        </div>
                      </div>
                    );
                  }}
                />
              </div>
            </div>
          </div>
        )}

        <div className="flex space-x-4">
          <div className="w-full">
            {!pathname.includes("activity") && (
              <h4 className="text-sm leading-3 tracking-tight font-bold text-[#535860] pb-1 border-b border-[#D9D9D9]">
                Preview
              </h4>
            )}

            {!showWatermark && (
              <ReusableGridLayoutPreview
                setShowWatermark={setShowWatermark}
                setShowSetting={setShowSetting}
                showSetting={showSetting}
                setComponentForSetting={setComponentForSetting}
                deletedComponentIdList={deletedComponentIdList}
                setDeletedComponentIdList={setDeletedComponentIdList}
                componentForSetting={componentForSetting}
              />
            )}
          </div>
        </div>

        <div
          ref={triggerRef}
          className={`fixed inset-0 bg-slate-500 bg-opacity-50 z-40 transition-opacity duration-200 ${
            showSetting ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
          aria-hidden="true"
        ></div>

        <div
          ref={settingRef}
          className={`w-[40%] rounded-lg z-60 bg-white absolute top-0 transition-transform duration-200 ease-in-out ${
            !showSetting ? "right-0 translate-x-full" : "translate-x-0 right-0"
          }`}
        >
          <ReusableComponentSetting
            componentForSetting={componentForSetting}
            setComponentForSetting={setComponentForSetting}
            setShowSetting={setShowSetting}
            showSetting={showSetting}
          />
        </div>

        {showWatermark && !todoDataForUpdateInventory && (
          <div
            className="h-screen flex justify-center items-center"
            style={{ maxHeight: "calc(100vh - 185px)" }}
          >
            <div
              className="w-2/3 h-2/3 bg-center bg-opacity-25 flex justify-center items-center"
              style={{
                backgroundImage:
                  "linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(" +
                  Image +
                  ")",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="text-center">
                <h4 className="text-[15px] leading-7 tracking-tight font-bold text-[#1E293B] ">
                  Drag and drop any component from list
                </h4>
                <p className="text-[15px] leading-7 tracking-tight text-[#1E293B]">
                  to design your own template
                </p>
              </div>
            </div>
          </div>
        )}

        <div
          className={`absolute bottom-0 w-full py-2 flex ${
            pathname.includes("activity") ? "justify-between" : "justify-end"
          } items-center`}
        >
          {pathname.includes("activity") && (
            <button
              className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 cursor-pointe space-x-2"
              onClick={() => {
                setStep(1);
                dispatch({ type: SET_RETAIN_PROPS, payload: true });
              }}
            >
              <span className="fa-solid fa-chevron-left" />
              <span>Prev</span>
            </button>
          )}
          <div className="space-x-4">
            <button
              className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 cursor-pointer"
              onClick={() => {
                if (
                  tempPageName === "manage todo" ||
                  tempPageName === "manage template"
                ) {
                  dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
                }
                if (pathname.includes("activity")) {
                  navigate("/activity/overview");
                } else {
                  navigate("/booking/design/overview");
                }
                dispatch({ type: CLEAR_COMPONENT_PREVIEW_DATA });
                dispatch({ type: CLEAR_COMPONENT_GRID_LAYOUT_DATA });
                dispatch({ type: CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY });
              }}
            >
              Cancel
            </button>

            <button
              className={`btn ${isSaved ? "!bg-[--bg-color-400] cursor-not-allowed" : "!bg-[--bg-color-500] cursor-pointer" } !hover:bg-[--bg-color-600] text-white `}
              onClick={() => {
                setIsSaved(true);
                state ? updateCustomField() : addCustomField();
                dispatch({ type: CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY });
              }}
              disabled={isSaved}
            >
              {state ? pathname.includes("activity") ? "Next" : "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

CreateAndUpdateTemplate.auth = {
  path: "/booking/design/create",
  role: "super-admin admin",
};
export default CreateAndUpdateTemplate;
